import React from "react";
import withShipment from "../../../../withShipment";
import './CompanySelectBox.css';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { selectedCompanyIdSelector } from '../../../../redux/selectors/auth';
import PropTypes from "prop-types";
import { updateSelectedCompany } from '../../../../redux/actions/auth';
import { availableCompaniesSelector } from '../../../../redux/selectors/account';

class CompanySelectBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedCompany: this.getSelectedCompany(),
            alternativeValues: this.props.alternativeValues || [],
            availableCompanies: this.getAvailableCompanies()
        };
    }


    componentDidUpdate(prevProps) {
        // Only update if props related to company selection change
        if (
            this.props.alternativeValues !== prevProps.alternativeValues ||
            this.props.selectedLocationId !== prevProps.selectedLocationId ||
            this.props.availableCompanies !== prevProps.availableCompanies
        ) {
            // Prevent unnecessary state updates if available companies and selected company haven't changed
            const newAvailableCompanies = this.getAvailableCompanies();
            const newSelectedCompany = this.getSelectedCompany();

            if (
                JSON.stringify(newAvailableCompanies) !== JSON.stringify(this.state.availableCompanies) ||
                JSON.stringify(newSelectedCompany) !== JSON.stringify(this.state.selectedCompany)
            ) {
                this.setState({
                    selectedCompany: newSelectedCompany,
                    alternativeValues: this.props.alternativeValues || [],
                    availableCompanies: newAvailableCompanies
                });
            }
        }
    }

    // Simplified method to calculate available companies
    getAvailableCompanies = () => {
        const { availableCompanies = [], alternativeValues = []} = this.props;

        return availableCompanies.concat(
            alternativeValues.map(value => ({ name: value, companyId: value }))
        );
    }

    getSelectedCompany = () => {
        const { selectedLocationId, availableCompanies } = this.props;
        const selectedCompany = availableCompanies.find((value) => value.companyId === selectedLocationId);
        return selectedCompany || {};
    }

    render() {
    const isMobile = window.innerWidth <= 768;
        return (
          <React.Fragment>
            <div className="company-select-wrapper">
            <Autocomplete
              options={this.state.availableCompanies}
              getOptionLabel={(entry) => entry.companyCode ? `${entry.name} (${entry.companyCode})` : (entry.name || '')}
              autoHighlight={true}
              disableClearable
              onChange={(event, value) => {
                if (!this.state.alternativeValues?.includes(value.companyId)) {
                  this.props.updateSelectedCompany(value.companyId, value.name);
                }
                if (this.props.updateCallback) {
                  this.props.updateCallback(value);
                }
              }}
              blurOnSelect={true}
              disablePortal={isMobile}
              filterOptions={(opts, state) =>
                opts.filter((o) => {
                  const input = state.inputValue.toLowerCase();
                  return o.name.toLowerCase().includes(input) ||
                    (o.companyCode && o.companyCode.toLowerCase().includes(input));
                })
              }
              value={
                this.props.selectedAlternativeValue ||
                this.state.selectedCompany
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Company"
                  onFocus={(e) => {
                    // 1. Persist the event (older React versions)
                    // OR simply capture the target in a variable (recommended)
                    const target = e.target;

                    setTimeout(() => {
                      // 2. Use the variable instead of e.target
                      if (target) {
                        target.scrollIntoView({
                          behavior: 'smooth',
                          block: 'center',
                        });
                      }
                    }, 300);
                  }}
                  variant="outlined"
                  name="companySelect"
                />
              )}
            />
            </div>
          </React.Fragment>
        );
    }
}

CompanySelectBox.propTypes = {
    selectedCompany: PropTypes.object,
    alternativeValues: PropTypes.array,
    availableCompanies: PropTypes.array,
    selectedLocationId: PropTypes.string,
    updateSelectedCompany: PropTypes.func,
    updateCallback: PropTypes.func,
    selectedAlternativeValue: PropTypes.object,
    selectedLocations: PropTypes.array,
    userInfo: PropTypes.object
};

const mapStateToProps = (state) => ({
    availableCompanies: availableCompaniesSelector(state),
    selectedLocationId: selectedCompanyIdSelector(state)
});

const actionCreators = {
    updateSelectedCompany
};

export default withShipment({
    mapStateToProps,
    actionCreators
}, CompanySelectBox);
